/**
 * One handle on the one "Lägg till" menu. It is a sheet, not a place: Hem and
 * the empty Att göra ask for it through this hook instead of growing a second
 * surface. Outside the shell it falls back to /lagg-till, which renders the
 * same `AddMenu` as a page.
 */
import { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

/** Provided by AppShell; null outside it (onboarding, /kamera, /dela). */
export const OpenAddMenuContext = createContext<(() => void) | null>(null);

export function useOpenAddMenu(): () => void {
  const open = useContext(OpenAddMenuContext);
  const navigate = useNavigate();
  return open ?? (() => navigate('/lagg-till'));
}
